export const VerifyEmailRibbon = () => {
  return (
    <>
      <div
        style={{
          textAlign: "center",
          padding: "10px 0px",
          fontSize: "10pt",
          width: "100%",
          //position: "fixed",
          //zIndex: "1000"
        }}
        className="color_yellow_500"
      >
        <p style={{ fontWeight: "bold" }} className="text_color_orange_700">
          Please verify your email address.
        </p>
      </div>
    </>
  );
};
